const isObject = (maybeObj: any): boolean => {
  return Object.prototype.toString.call(maybeObj) === "[object Object]";
};

export default isObject;
